import React, { useState, useEffect } from "react";
import { PropTypes } from "prop-types";
import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
//components
import TabList from "./TabList";
import SelectedTabView from "../SelectedTabView";
import AppHoc from "../../../../generics/AppHOC";

//style file
import css from "../../reportsMagneticStyle.less";

//reducers file
import * as actions from "../actions";
import { routeURLs } from "../../../../utils/enums";

//i18n file
import { useI18n } from "../../../../i18n/useI18n";

const mapStateToProps = state => {
  return {
    reports: state.vanalytics.reports
  };
};
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

const ReportTabList = props => {
  const location = useLocation();
  const [component, setComponent] = useState(<></>);
  const [reportsCount, setReportsCount] = useState(0);

  useEffect(() => {
    setReportsCount(props?.globalFilter?.reportsDataCount);
    setComponent(<TabComponent reportsCount={reportsCount} reportTabPath={location.hash} />);
  }, [props, reportsCount, location.hash]);

  return component;
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(AppHoc(ReportTabList))
);

const TabComponent = props => {
  const { tViews } = useI18n('views');
  const navigate = useNavigate();
  const [reportTemplate, setReportTemplate] = useState();
  // Report view change on click of tab
  const changeReportView =(templateView) => {
    let reportPathView;
    if(templateView ==='reportTemplates') {
      reportPathView = "#report-templates";
    } else {
      reportPathView = "#generated-reports";
    }
    navigate(`${routeURLs.reports}${reportPathView}`);
    setReportTemplate(templateView);
  }
  // Default report view set, onclick of side bar reports submenu
  useEffect(() => {
    let defaultTabValue;
    if(props.reportTabPath ==='#report-templates') {
      defaultTabValue = "reportTemplates";
    } else {
      defaultTabValue = "generatedReports";
    }
    setReportTemplate(defaultTabValue);
  }, [props.reportTabPath]);

  const tabList = [
    {
      label: tViews('reportGeneratedReports'),
      name: "generatedReports",
      count: props.reportsCount
    },
    {
      label: tViews('reportReportTemplates'),
      name: "reportTemplates"
    }
  ];

  return (
    <div className={css["report-container"]} data-cy="tab-report-view">
      <div className="app-label hbr-type-h1"role="heading" aria-level={'1'}>{tViews('reportsTitle')}</div>
      <TabList
        tabs={tabList}
        defaultTabValue={reportTemplate}
        changeReportView={changeReportView}
      />
      <SelectedTabView tabContent={reportTemplate} />
    </div>
  );
};

TabComponent.propTypes = {
  reportsCount: PropTypes.number,
  reportTabPath: PropTypes.string
};
